/**
 * 法人ダッシュボードで選択中の組織を localStorage に覚えておく。
 *
 * 1ユーザーが複数組織に所属しうるので、同じブラウザで別ユーザーがログインしたときに
 * 取り違えないよう uid でキーを分ける。値は必ず所属一覧と突き合わせてから使う。
 */
const KEY_PREFIX = "hinome_corporate_selected_organization";

type Membership = { organization_id: string };

const storageKey = (uid: string) => `${KEY_PREFIX}:${uid}`;

export const readSelectedOrganizationId = (uid?: string | null): string | null => {
  if (typeof window === "undefined" || !uid) return null;
  try {
    return window.localStorage.getItem(storageKey(uid));
  } catch {
    return null;
  }
};

export const writeSelectedOrganizationId = (uid?: string | null, organizationId?: string | null): void => {
  if (typeof window === "undefined" || !uid || !organizationId) return;
  try {
    window.localStorage.setItem(storageKey(uid), organizationId);
  } catch {
    // プライベートモード等で失敗しても画面は動かす
  }
};

export const clearSelectedOrganizationId = (uid?: string | null): void => {
  if (typeof window === "undefined" || !uid) return;
  try {
    window.localStorage.removeItem(storageKey(uid));
  } catch {
    // noop
  }
};

/**
 * 選択中の組織を決める。
 * 指定 > 保存値(所属一覧にある場合のみ) > 先頭 の順。
 */
export const resolveSelectedOrganizationId = (
  memberships: Membership[],
  storedId?: string | null,
  preferredId?: string | null,
): string | null => {
  if (!memberships.length) return null;
  const has = (id?: string | null) => !!id && memberships.some((m) => m.organization_id === id);
  if (has(preferredId)) return preferredId as string;
  if (has(storedId)) return storedId as string;
  return memberships[0].organization_id;
};
